import { render, staticRenderFns } from "./SchoolVerticalNavMenu.vue?vue&type=template&id=78c141ea&scoped=true&"
import script from "./SchoolVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./SchoolVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./SchoolVerticalNavMenu.vue?vue&type=style&index=0&id=78c141ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c141ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VImg,VList,VNavigationDrawer,VSlideXTransition})
